module.exports = "<app-last-files [colSize]=\"12\" [fileType]=\"'unsubscribe'\"></app-last-files>\n"


//////////////////
// WEBPACK FOOTER
// /home/jacobo/proyectos/venta-extranet/src/app/config/components/dashboard/dashboard.component.html
// module id = ../../../../../src/app/config/components/dashboard/dashboard.component.html
// module chunks = main